import { render, staticRenderFns } from "./BaseTextLabeled.vue?vue&type=template&id=226a20c0&"
import script from "./BaseTextLabeled.vue?vue&type=script&lang=js&"
export * from "./BaseTextLabeled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports